import Icon from "@mui/material/Icon"
import { Skeleton } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { ProfileHeader } from "./ProfileHeader"
import DateSelect from "components/DateSelect/temp3"
import ReactPaginate from "react-paginate"
import { selectAuth } from "shared/redux/slices/authSlice"
import MDSnackbar from "components/MDSnackbar"

import { useLazyGetPaySlipListQuery } from "shared/redux/endpoints/employee"
import { useEffect, useState } from "react"
import moment from "moment"
import { enUS } from "date-fns/locale"

import { ReactComponent as ViewIcon } from "assets/images/icons/view.svg"

import "./LeaveSystem.scss"
import "./PaySlips.scss"
import { useSelector } from "react-redux"
import ModalPaySlipDetail from "components/ModalPaySlipDetail/ModalPaySlipDetail"

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]

const getMonthLabel = (month, year) => {
  const monthName = MONTH_NAMES[month - 1] || "—"
  const fullMonthName = new Date(year, month - 1, 1).toLocaleString("en-US", {
    month: "long",
  })
  return { short: monthName, full: `${fullMonthName} ${year}` }
}

export const PaySlips = () => {
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD")
  const currentDate = moment().endOf().format("YYYY-MM-DD")
  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 0,
  })
  const [dataModal, setDataModal] = useState({})
  const [modalPaySlipInfo, setModalPaySlipInfo] = useState(false)
  const auth = useSelector(selectAuth)
  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  })

  const [getListPaySlip, { isLoading: isLoadingLeave }] =
    useLazyGetPaySlipListQuery()

  const [state, setState] = useState({
    page: 0,
    size: 10,
    startDate: startOfYear,
    endDate: currentDate,
    dayType: "FULL_DAY",
  })
  const [rows, setRows] = useState([])

  const buildPaySlipRowsFromLastYearToCurrentMonth = () => {
    const now = moment()
    const currentYear = now.year()
    const lastYear = currentYear - 1
    const currentMonth = now.month() + 1

    const builtRows = []

    for (let m = 1; m <= 12; m += 1) {
      builtRows.push({
        month: m,
        year: lastYear,
        workdays: "-",
        status: "APPROVED",
        currentMonth: `${String(m).padStart(2, "0")}/${lastYear}`,
      })
    }

    for (let m = 1; m <= currentMonth; m += 1) {
      builtRows.push({
        month: m,
        year: currentYear,
        workdays: "-",
        status: "APPROVED",
        currentMonth: `${String(m).padStart(2, "0")}/${currentYear}`,
      })
    }

    return builtRows
  }

  const sortNewestFirst = (items) =>
    items.slice().sort((a, b) => b.year - a.year || b.month - a.month)

  const paginateRows = (items, page, size) => {
    const start = page * size
    return items.slice(start, start + size)
  }

  const handlderAPIList = (params) => {
    const allRows = sortNewestFirst(
      buildPaySlipRowsFromLastYearToCurrentMonth()
    )

    const totalPage = Math.max(1, Math.ceil(allRows.length / params.size))
    const pagedRows = paginateRows(allRows, params.page, params.size)

    setRows(pagedRows)
    setPagination({ totalPage, currentPage: params.page })
  }

  useEffect(() => {
    handlderAPIList(state)
  }, [state.page, state.size])

  const handleChangePage = (page) => {
    setState((prev) => ({ ...prev, page }))
  }

  const handlerClickView = (data) => {
    setDataModal({ ...data, empCode: auth.user.empCode })
    setModalPaySlipInfo(true)
  }

  const propsModalPaySlipDetail = {
    isOpen: modalPaySlipInfo,
    onClose: () => setModalPaySlipInfo(false),
    data: dataModal,
    openSnackbar,
    setOpenSnackbar,
  }

  const totalEntries = sortNewestFirst(
    buildPaySlipRowsFromLastYearToCurrentMonth()
  ).length

  return (
    <MDBox customClass="c-leave-system payslip-tab">
      <MDBox>
        <MDBox mt={2} mb={3}>
          <ProfileHeader />
        </MDBox>

        <MDBox mt={2} className="payslip-tab--dashboard">
          <MDTypography className="payslip-tab--title">
            Personal Payslip
          </MDTypography>
          <MDTypography className="payslip-tab--subtitle">
            Review your monthly salary statements and download PDF copies.
          </MDTypography>

          <MDBox display="flex" gap={2} mb={2.5} alignItems="center">
            <DateSelect
              onChangeStartDate={(e) => {
                setState({
                  ...state,
                  startDate: moment(e).format("YYYY-MM-DD"),
                })
              }}
              onChangeEndDate={(e) => {
                setState({
                  ...state,
                  endDate: moment(e).format("YYYY-MM-DD"),
                })
              }}
              defaultStartDate={state.startDate}
              defaultEndDate={state.endDate}
              locale={enUS}
            />
          </MDBox>

          <MDBox className="pay-slip-table payslip-history">
            {isLoadingLeave
              ? Array.from({ length: 5 }).map((_, index) => (
                  <MDBox key={index} className="payslip-history__skeleton">
                    <Skeleton variant="rounded" width={44} height={44} />
                    <MDBox flex={1}>
                      <Skeleton variant="text" width="40%" height={20} />
                      <Skeleton variant="text" width="25%" height={16} />
                    </MDBox>
                    <Skeleton variant="rounded" width={128} height={36} />
                  </MDBox>
                ))
              : rows.map((item) => {
                  const { short, full } = getMonthLabel(item.month, item.year)
                  return (
                    <MDBox
                      key={`${item.year}-${item.month}`}
                      className="payslip-history__row"
                      onClick={() => handlerClickView(item)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handlerClickView(item)
                        }
                      }}
                    >
                      <MDBox className="payslip-history__icon">
                        <span className="payslip-history__icon-month">
                          {short}
                        </span>
                        <span className="payslip-history__icon-year">
                          {item.year}
                        </span>
                      </MDBox>

                      <MDBox className="payslip-history__content">
                        <MDTypography className="payslip-history__label">
                          {full}
                        </MDTypography>
                        <MDTypography className="payslip-history__meta">
                          Monthly payslip · {item.status.toLowerCase()}
                        </MDTypography>
                      </MDBox>

                      <MDTypography className="payslip-history__action">
                        <ViewIcon /> View Payslip
                      </MDTypography>
                    </MDBox>
                  )
                })}
          </MDBox>

          <MDBox className="table-footer">
            <MDBox className="table-footer-showing">
              Showing {rows.length} of {totalEntries} entries
            </MDBox>
            {pagination.totalPage >= 0 && (
              <ReactPaginate
                className="pagination"
                nextLabel={<Icon>chevron_right</Icon>}
                previousLabel={<Icon>chevron_left</Icon>}
                forcePage={Number(state.page)}
                onPageChange={(event) => handleChangePage(event.selected)}
                pageCount={pagination.totalPage}
              />
            )}
          </MDBox>
        </MDBox>
      </MDBox>

      {modalPaySlipInfo && <ModalPaySlipDetail {...propsModalPaySlipDetail} />}
      <MDSnackbar
        color={openSnackbar.severity}
        icon="check"
        title="PaySlip"
        content={openSnackbar.message}
        open={openSnackbar.open}
        onClose={() => setOpenSnackbar({ ...openSnackbar, open: false })}
        close={() => setOpenSnackbar({ ...openSnackbar, open: false })}
        bgWhite
      />
    </MDBox>
  )
}
